import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Facultad } from '../models/t4_facultades.model';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FacultadesService {

  constructor(private http: HttpClient) { }

  getToken(): string {
    return <string>localStorage.getItem('access_token');
  }

  // Método para crear headers con el token
  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Authorization': `Bearer ${this.getToken()}`
    });
  }

  getDataFilter(page: any, filtro: Facultad): Observable<Facultad[]> {
    const headers = this.getHeaders();
    let params = new HttpParams();
    params = params.append('index', filtro.Name);
    if(page!=0){
      params = params.append('size', page.size);
      params = params.append('offset', page.offset);
    }
    return this.http.get<Facultad[]>(`${environment.apiUrl}/facultades`, { headers, params });
  }

}
